module.exports = __webpack_public_path__ + "img/receipt_logo.41b2ecb5.png";